/*
 * Sutrisha Cart Core
 * One authoritative cart state + one serialized mutation queue.
 * Gift reconciliation is transactional: desired presence -> explicit Shopify reprice -> verify.
 * No global fetch interception, polling, settlement timers, or basis-block hacks.
 */
(function(){
'use strict';
if(window.wlCartCore)return;

var STATE='wl-cart-state';
var queue=Promise.resolve();
var cache=null;
var pdpWarm=null;
var giftBlocked=false; /* Shopify refused to zero-rate the gift: stop re-attempting every mutation */

function num(v){var n=parseInt(v,10);return isNaN(n)?0:n;}
function clone(v){try{return JSON.parse(JSON.stringify(v));}catch(_){return v;}}
function emit(name,detail){try{document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:detail||{}}));}catch(_){} }
function giftCfg(){var g=window.WL_GIFT;return g&&g.vid&&Number(g.min)>0?{vid:Number(g.vid),min:Number(g.min)}:null;}
/* Liquid renders line properties as [[key,value],...]; the cart API only accepts a hash. */
function toProps(p){if(Array.isArray(p)){var o={};p.forEach(function(kv){if(kv&&kv.length)o[kv[0]]=kv.length>1?kv[1]:'';});return o;}return p&&typeof p==='object'?p:{};}

function normalizeState(s){
 if(!s||!Array.isArray(s.lines))return null;
 ['itemCount','rawItemCount','itemsSubtotalPrice','originalTotalPrice','totalPrice','totalDiscount','giftVid','giftBasis','giftCount','giftQty','giftCharged','protectVid'].forEach(function(k){s[k]=num(s[k]);});
 s.discounts=Array.isArray(s.discounts)?s.discounts:[];
 s.lines=s.lines.map(function(l){
   l=l||{};
   ['line','vid','pid','qty','originalLine','finalLine','originalPrice','finalPrice','compareAt'].forEach(function(k){l[k]=num(l[k]);});
   l.key=String(l.key||'');l.title=String(l.title||'');l.variantTitle=String(l.variantTitle||'');l.url=String(l.url||'');
   l.properties=toProps(l.properties);
   l.sellingPlan=l.sellingPlan==null?null:l.sellingPlan;
   l.gift=!!l.gift;l.hidden=!!l.hidden;
   return l;
 });
 return s;
}
function parseStateHTML(html){
 if(typeof html!=='string')return null;
 var box=document.createElement('div');box.innerHTML=html;
 var el=box.querySelector('#wl-cart-state');if(!el)return null;
 try{return normalizeState(JSON.parse(el.textContent||'{}'));}catch(_){return null;}
}
function bootstrap(){if(cache)return cache;cache=normalizeState(clone(window.WL_CART_BOOT));return cache;}
function stateFrom(data){
 var html=data&&data.sections&&data.sections[STATE],s=parseStateHTML(html);
 if(s){cache=s;syncDomLines(s);emit('wl:cart:state',{state:s,data:data});}
 return s;
}
function current(){return cache||bootstrap();}
function sectionNames(extra){var a=[];(extra||[]).forEach(function(x){if(x&&x!==STATE&&a.indexOf(x)<0)a.push(x);});a.push(STATE);return a;}
function syncDomLines(s){
 s=s||current();if(!s||!s.lines)return;
 function mapRows(rows,vidAttr){
   var seen={};[].forEach.call(rows,function(row){
     var vid=num(row.getAttribute(vidAttr));if(!vid)return;
     var n=seen[vid]||0;seen[vid]=n+1;
     var line=s.lines.filter(function(l){return !l.hidden&&l.vid===vid;})[n];if(!line)return;
     row.setAttribute('data-wl-line',String(line.line));row.setAttribute('data-line',String(line.line));row.setAttribute('data-wl-key',line.key);
     row.querySelectorAll('[data-line],[data-index]').forEach(function(el){if(el.hasAttribute('data-line'))el.setAttribute('data-line',String(line.line));if(el.hasAttribute('data-index'))el.setAttribute('data-index',String(line.line));});
     row.querySelectorAll('.wl-size[data-wl-sizedd]').forEach(function(el){el.setAttribute('data-line',String(line.line));});
   });
 }
 var d=document.getElementById('CartDrawer');if(d)mapRows(d.querySelectorAll('hdt-line-item[data-wl-vid]'),'data-wl-vid');
 var p=document.getElementById('hdt-page-cart');if(p)mapRows(p.querySelectorAll('.wl-cart-item[data-vid]'),'data-vid');
}

function readResponse(r){
 return r.text().then(function(t){
   var data={};try{data=t?JSON.parse(t):{};}catch(_){throw new Error('Invalid cart response');}
   if(!r.ok){var e=new Error(data.description||data.message||('Cart request failed ('+r.status+')'));e.status=r.status;e.data=data;throw e;}
   stateFrom(data);return data;
 });
}
function requestJSON(url,body,extra,sectionsUrl){
 body=Object.assign({},body||{});body.sections=sectionNames(extra);body.sections_url=sectionsUrl||'/';
 emit('wl:cart:before',{url:url,body:clone(body)});
 return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(readResponse);
}
function requestForm(url,formData,extra,sectionsUrl){
 var fd=new FormData();formData.forEach(function(v,k){if(k!=='sections'&&k!=='sections_url')fd.append(k,v);});
 fd.append('sections',sectionNames(extra).join(','));fd.append('sections_url',sectionsUrl||'/');
 emit('wl:cart:before',{url:url,form:true});
 return fetch(url,{method:'POST',headers:{Accept:'application/json'},body:fd}).then(readResponse);
}
function readFresh(extra,sectionsUrl){
 var qs=sectionNames(extra).map(encodeURIComponent).join(','),base=sectionsUrl||'/',sep=base.indexOf('?')>-1?'&':'?';
 return fetch(base+sep+'sections='+qs,{headers:{Accept:'application/json'}}).then(function(r){return r.text().then(function(t){var d={};try{d=JSON.parse(t);}catch(_){throw new Error('Invalid cart state');}var data={sections:d};if(!stateFrom(data))throw new Error('Cart state unavailable');return data;});});
}
function state(extra,sectionsUrl){var s=current();return s?Promise.resolve(s):readFresh(extra,sectionsUrl).then(function(){return cache;});}
function run(fn){var p=queue.then(fn,fn);queue=p.then(function(){},function(){});return p.catch(function(e){emit('wl:cart:error',{error:e});throw e;});}

function lineByIndex(s,line){line=num(line);return(s&&s.lines||[]).filter(function(l){return l.line===line;})[0]||null;}
function lineByKey(s,key){key=String(key||'');return(s&&s.lines||[]).filter(function(l){return l.key===key;})[0]||null;}
function sameProps(a,b){function stable(o){if(!o||typeof o!=='object')return'{}';var keys=Object.keys(o).sort(),x={};keys.forEach(function(k){x[k]=o[k];});return JSON.stringify(x);}return stable(a)===stable(b);}
function signatureLine(s,vid,props,sellingPlan,excludeKey){return(s&&s.lines||[]).filter(function(l){return l.vid===Number(vid)&&l.key!==String(excludeKey||'')&&String(l.sellingPlan||'')===String(sellingPlan||'')&&sameProps(l.properties,props||{});})[0]||null;}
function giftLines(s){return(s&&s.lines||[]).filter(function(l){return l.gift;});}
function giftShapeExact(s){return!!(s&&s.giftCount===1&&s.giftQty===1);}
function giftExact(s){return!!(giftShapeExact(s)&&s.giftCharged===0);}
function hasPurchases(s){return!!(s&&s.lines&&s.lines.some(function(l){return !l.gift&&!l.hidden&&l.qty>0;}));}
function hasManualCode(s){return!!(s&&s.discounts&&s.discounts.some(function(d){return String(d&&d.type||'').toLowerCase()==='discount_code';}));}

function removeLinesSequential(lines,extra,sectionsUrl){
 lines=(lines||[]).slice().sort(function(a,b){return b.line-a.line;});var last=null,chain=Promise.resolve();
 lines.forEach(function(seed){chain=chain.then(function(){var s=current(),live=lineByKey(s,seed.key)||signatureLine(s,seed.vid,seed.properties,seed.sellingPlan);if(!live)return last;return requestJSON('/cart/change.js',{line:live.line,quantity:0},extra,sectionsUrl).then(function(d){last=d;return d;});});});
 return chain.then(function(){return last;});
}
function addFreeGift(extra,sectionsUrl){var g=giftCfg();return g?requestJSON('/cart/add.js',{id:g.vid,quantity:1},extra,sectionsUrl):Promise.resolve(null);}
function repriceGift(s,extra,sectionsUrl){
 var line=giftLines(s)[0];if(!line||!line.key)return Promise.resolve(null);
 var updates={};updates[line.key]=1;
 return requestJSON('/cart/update.js',{updates:updates},extra,sectionsUrl);
}
function failGift(data,s,extra,sectionsUrl,block){
 if(block)giftBlocked=true;
 emit('wl:cart:gift-unavailable',{state:clone(s||current()),blocked:!!block});
 var x=s||current();return x&&x.giftCount?removeLinesSequential(giftLines(x),extra,sectionsUrl).then(function(d){return d||data;}):Promise.resolve(data);
}
function verifyGift(data,extra,sectionsUrl){
 var s=(data&&stateFrom(data))||current();if(!s)return Promise.resolve(data);
 if(giftExact(s))return Promise.resolve(data);
 if(!giftShapeExact(s))return failGift(data,s,extra,sectionsUrl,false);
 return repriceGift(s,extra,sectionsUrl).then(function(repriced){
   var after=(repriced&&stateFrom(repriced))||current();
   if(after&&giftExact(after))return repriced;
   /* the gift is present and correctly shaped yet still billed: the store has no
      active zero-rating discount, so stop re-attempting it on every mutation. */
   return failGift(repriced||data,after||s,extra,sectionsUrl,!!(after&&giftShapeExact(after)&&after.giftCharged>0));
 });
}
function reconcileGift(data,extra,sectionsUrl){
 var g=giftCfg(),s=(data&&stateFrom(data))||current();if(!g||!s)return Promise.resolve(data);
 if(s.giftBasis<g.min||giftBlocked){return s.giftCount?removeLinesSequential(giftLines(s),extra,sectionsUrl).then(function(d){return d||data;}):Promise.resolve(data);}
 if(giftExact(s))return Promise.resolve(data);
 if(giftShapeExact(s))return verifyGift(data,extra,sectionsUrl);
 var clean=s.giftCount?removeLinesSequential(giftLines(s),extra,sectionsUrl):Promise.resolve(data);
 return clean.then(function(){return addFreeGift(extra,sectionsUrl);}).then(function(d){return verifyGift(d,extra,sectionsUrl);});
}
function clearEmptyCodes(data,extra,sectionsUrl){
 var s=(data&&stateFrom(data))||current();if(!s||hasPurchases(s)||!hasManualCode(s))return Promise.resolve(data);
 return requestJSON('/cart/update.js',{discount:''},extra,sectionsUrl);
}
function finalize(data,extra,sectionsUrl){return reconcileGift(data,extra,sectionsUrl).then(function(d){return clearEmptyCodes(d,extra,sectionsUrl);});}

function changePlan(s,l,qty){
 if(!s||!l||!l.key)return null;qty=num(qty);
 var purchasesAfter=(s.lines||[]).some(function(x){if(x.gift||x.hidden)return false;if(x.key===l.key)return qty>0;return x.qty>0;});
 var basis=s.giftBasis;if(!l.gift&&!l.hidden){var unit=l.qty?Math.round(l.originalLine/l.qty):l.originalPrice;basis=s.giftBasis-l.originalLine+(unit*qty);}
 var g=giftCfg(),dropGift=!!(g&&s.giftCount&&basis<g.min),empties=!purchasesAfter;if(!dropGift&&!empties)return null;
 var updates={};updates[l.key]=qty;if(dropGift)giftLines(s).forEach(function(x){if(x.key)updates[x.key]=0;});if(empties)(s.lines||[]).forEach(function(x){if(x.hidden&&x.key)updates[x.key]=0;});
 var body={updates:updates};if(empties&&hasManualCode(s))body.discount='';return{body:body,empties:empties};
}
function change(lineRef,qty,extra,sectionsUrl){
 return state(extra,sectionsUrl).then(function(s){
   var l=typeof lineRef==='number'?lineByIndex(s,lineRef):lineByKey(s,lineRef),q=Number(qty);if(!l)throw new Error('Cart line changed. Please try again.');
   var plan=changePlan(s,l,q);if(plan){if(plan.empties)emit('wl:cart:emptying',{state:clone(s),line:clone(l),quantity:q});return requestJSON('/cart/update.js',plan.body,extra,sectionsUrl);}
   return requestJSON('/cart/change.js',{line:l.line,quantity:q},extra,sectionsUrl);
 }).then(function(d){return finalize(d,extra,sectionsUrl);});
}

function warmData(){if(pdpWarm)return pdpWarm;var el=document.getElementById('wl-pdp-cart-warm');if(!el)return null;try{pdpWarm=JSON.parse(el.textContent||'{}');}catch(_){pdpWarm=null;}return pdpWarm;}
function simpleFormItem(fd){
 if(!fd||typeof fd.getAll!=='function')return null;var ids=fd.getAll('id').filter(function(v){return String(v||'').trim()!=='';}),nested=false,props={};if(ids.length!==1||fd.getAll('quantity').length>1)return null;
 fd.forEach(function(v,k){var m=/^properties\[(.*)\]$/.exec(k);if(/\[id\]$/.test(k))nested=true;if(m)props[m[1]]=String(v);});if(nested||fd.get('selling_plan')||fd.get('selling_plan_id'))return null;
 var id=Number(ids[0]),qty=Number(fd.get('quantity')||1);if(!id||!qty||qty<1)return null;var item={id:id,quantity:qty};if(Object.keys(props).length)item.properties=props;return item;
}
function warmGiftEligible(item){var g=giftCfg(),s=current(),w=warmData();if(giftBlocked||!g||!s||!w||!item||s.giftCount||item.id===g.vid)return false;var price=num(w.variants&&w.variants[String(item.id)]);return price>0&&(s.giftBasis+(price*item.quantity)>=g.min);}
function addJSON(body,extra,sectionsUrl){return requestJSON('/cart/add.js',body,extra,sectionsUrl).then(function(d){return finalize(d,extra,sectionsUrl);});}
function addForm(fd,extra,sectionsUrl){
 var item=simpleFormItem(fd),g=giftCfg();
 if(item&&g&&warmGiftEligible(item)){emit('wl:cart:warm-gift',{variantId:item.id,giftVariantId:g.vid});return requestJSON('/cart/add.js',{items:[item,{id:g.vid,quantity:1}]},extra,sectionsUrl).then(function(d){return finalize(d,extra,sectionsUrl);});}
 return requestForm('/cart/add.js',fd,extra,sectionsUrl).then(function(d){return finalize(d,extra,sectionsUrl);});
}
function discount(codes,extra,sectionsUrl){return requestJSON('/cart/update.js',{discount:String(codes||'')},extra,sectionsUrl).then(function(d){return finalize(d,extra,sectionsUrl);});}
function update(body,extra,sectionsUrl,doSettle){return requestJSON('/cart/update.js',body,extra,sectionsUrl).then(function(d){return doSettle===false?d:finalize(d,extra,sectionsUrl);});}

function addItemFromLine(line,newVid,newQty){var x={id:Number(newVid),quantity:Number(newQty)};if(line.properties&&Object.keys(line.properties).length)x.properties=clone(line.properties);if(line.sellingPlan)x.selling_plan=line.sellingPlan;return x;}
/* update.js can zero the old line and set the new variant in ONE round trip, but it drops line
   properties and selling plans, so it is only used when the line carries neither. */
function swapPlan(before,old,newVid,newQty){
 if(!old.key||old.sellingPlan)return null;
 if(old.properties&&Object.keys(old.properties).length)return null;
 var prior=signatureLine(before,newVid,old.properties,old.sellingPlan,old.key);
 var updates={};updates[old.key]=0;updates[String(newVid)]=(prior?prior.qty:0)+newQty;
 return updates;
}
function swapVariant(lineRef,newVid,newQty,extra,sectionsUrl){
 return state(extra,sectionsUrl).then(function(before){
   var old=typeof lineRef==='number'?lineByIndex(before,lineRef):lineByKey(before,lineRef);if(!old)throw new Error('Cart line changed. Please try again.');newVid=Number(newVid);newQty=Number(newQty||old.qty);if(!newVid||newVid===old.vid)return null;
   var fast=swapPlan(before,old,newVid,newQty);
   if(fast)return requestJSON('/cart/update.js',{updates:fast},extra,sectionsUrl).then(function(d){return finalize(d,extra,sectionsUrl);});
   var priorTarget=signatureLine(before,newVid,old.properties,old.sellingPlan,old.key),priorQty=priorTarget?priorTarget.qty:0;
   return requestJSON('/cart/add.js',addItemFromLine(old,newVid,newQty),extra,sectionsUrl).then(function(addData){
     var afterAdd=stateFrom(addData)||current(),liveOld=lineByKey(afterAdd,old.key)||signatureLine(afterAdd,old.vid,old.properties,old.sellingPlan);if(!liveOld)throw new Error('Could not change size safely.');
     return requestJSON('/cart/change.js',{line:liveOld.line,quantity:0},extra,sectionsUrl).then(function(removeData){return finalize(removeData,extra,sectionsUrl);}).catch(function(err){var now=current(),target=signatureLine(now,newVid,old.properties,old.sellingPlan);if(!target)throw err;return requestJSON('/cart/change.js',{line:target.line,quantity:priorQty},extra,sectionsUrl).then(function(){throw err;},function(){throw err;});});
   });
 });
}
function replaceVariant(vid,props,qty,extra,sectionsUrl){
 vid=Number(vid);qty=Number(qty||1);return state(extra,sectionsUrl).then(function(s){var found=(s.lines||[]).filter(function(l){return l.vid===vid&&!l.gift;});var p=found.length?removeLinesSequential(found,extra,sectionsUrl):Promise.resolve(null);return p.then(function(){var item={id:vid,quantity:qty};if(props&&Object.keys(props).length)item.properties=props;return addJSON({items:[item]},extra,sectionsUrl);});});
}
function syncGift(extra,sectionsUrl){return state(extra,sectionsUrl).then(function(){return reconcileGift(null,extra,sectionsUrl);}).then(function(d){return clearEmptyCodes(d,extra,sectionsUrl);});}
/* Re-read the live cart AND reconcile the gift. Every non-mutation refresh (bfcache restore,
   error recovery, a cart changed by Shiprocket / native form post / another tab) must go through
   here, otherwise a cart that crossed the threshold elsewhere shows "reward unlocked" with no gift.
   Queued itself, so never call it from inside a run() job. If the gift step fails, still return the
   live cart so callers can render it (the old plain re-read never failed on gift errors). */
function refresh(extra,sectionsUrl){return run(function(){cache=null;return readFresh(extra,sectionsUrl).then(function(d){return finalize(d,extra,sectionsUrl).catch(function(){cache=null;return readFresh(extra,sectionsUrl);});});});}

window.wlCartCore={
 run:run,state:state,current:current,stateFrom:stateFrom,readFresh:readFresh,invalidate:function(){cache=null;},
 requestJSON:requestJSON,requestForm:requestForm,change:change,addJSON:addJSON,addForm:addForm,discount:discount,update:update,
 settle:finalize,syncGift:syncGift,refresh:refresh,swapVariant:swapVariant,replaceVariant:replaceVariant,
 giftExact:giftExact,lineByIndex:lineByIndex,lineByKey:lineByKey,signatureLine:signatureLine,syncDomLines:syncDomLines,
 sections:function(extra){return sectionNames(extra);}
};
window.wlCartQueue=run;
window.wlCartInvalidate=function(){cache=null;};
document.addEventListener('wl:cart:render',function(){syncDomLines(current());});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){syncDomLines(current());},{once:true});else syncDomLines(current());
bootstrap();
})();
